"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RememberedAccountsViewContainer = void 0;
exports.mapDispatchToProps = mapDispatchToProps;
exports.mapStateToProps = mapStateToProps;
var _reactRedux = require("react-redux");
var _RememberedAccountsContainer = require("./RememberedAccountsContainer");
/*
 * TODO удалить этот код когда обновится react-redux@6 до react-redux@7 во frontend-mobile-website - https://jira.cian.tech/browse/AUD-1778
 * В react-redux@6 ещё не было useSelector и useDispatch, поэтому мы прокидываем их ручками.
 * После того как обновим старый мобсайт нужно использовать useSelector и useDispatch из react-redux,
 * а эти пропсы удалить вовсе. Прослойку connect больше ни для каких целей не используем, это временное решение.
 */

function mapDispatchToProps(dispatch) {
  return {
    useDispatch: () => dispatch
  };
}
function mapStateToProps(state) {
  return {
    source: state.source
  };
}
const RememberedAccountsViewContainer = exports.RememberedAccountsViewContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_RememberedAccountsContainer.RememberedAccountsContainer);